import { render, staticRenderFns } from "./MalfunctionExtraSelections.vue?vue&type=template&id=f37b57e6&scoped=true"
import script from "./MalfunctionExtraSelections.vue?vue&type=script&lang=js"
export * from "./MalfunctionExtraSelections.vue?vue&type=script&lang=js"
import style0 from "./MalfunctionExtraSelections.vue?vue&type=style&index=0&id=f37b57e6&prod&scoped=true&lang=css"
import style1 from "./MalfunctionExtraSelections.vue?vue&type=style&index=1&id=f37b57e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37b57e6",
  null
  
)

export default component.exports